<template>
    <div class="page-table mainDiv" id="affix-container">
        <div v-if="valueVisible" class="card-base animated fadeInUp baslikBg">
            {{$t("src.views.apps.firma.guncelleme.baslikDetay")}}
        </div>
        <div v-else class="card-base animated fadeInUp baslikBg">
            {{$t("src.views.apps.firma.guncelleme.baslikGuncelle")}}
        </div>
        <div class="animated fadeInUp">
            <el-form status-icon :model="firmaForm" :rules="rulesFirma" ref="firmaForm">
                <el-row :gutter="10">
                    <el-col :lg="12" :md="12" :sm="24" :xs="24">
                        <div class="flip-card" id="flipFirma">
                            <div class="flip-card-inner">
                                <div class="card-base card-shadow--medium">
                                    <div class="flip-card-front">
                                        <el-button v-if="root || guncellemeYetkisi" v-on:click="editShow('#flipFirma')"
                                                   type="warning" size="mini"
                                                   icon="el-icon-edit"></el-button>
                                        <el-divider content-position="left">Firma Bilgileri</el-divider>
                                        <div class="flex center demo-box" style="min-height: 277px">
                                            <div class="right-box box grow">
                                                <dl class="horizontal">
                                                    <dt><i class="mdi mdi-city"></i>{{$t("src.views.apps.firma.tanimlama.firmaKodu")}}
                                                    </dt>
                                                    <dd>: {{this.firmadetayi.firmaKodu}}</dd>
                                                    <el-divider></el-divider>
                                                    <dt><i class="mdi mdi-city"></i>{{$t("src.views.apps.firma.tanimlama.firmaAdi")}}
                                                    </dt>
                                                    <dd>: {{this.firmadetayi.firmaAdi}}</dd>
                                                    <el-divider></el-divider>
                                                    <dt><i class="mdi mdi-city-variant-outline"></i>{{$t("src.views.apps.firma.tanimlama.vergiDairesi")}}
                                                    </dt>
                                                    <dd>: {{this.firmadetayi.vergiDairesi}}</dd>
                                                    <el-divider></el-divider>
                                                    <dt><i class="mdi mdi-numeric"></i>{{$t("src.views.apps.firma.tanimlama.vergiNo")}}
                                                    </dt>
                                                    <dd>: {{this.firmadetayi.vergiNo}}</dd>
                                                </dl>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flip-card-back">
                                        <div class="btnBack">
                                            <el-button v-on:click="firmaGuncelleme('formName','#flipFirma')"
                                                       type="success"
                                                       size="mini"
                                                       icon="el-icon-check"></el-button>
                                            <el-button v-on:click="editClose('#flipFirma')" type="danger" size="mini"
                                                       icon="el-icon-close"></el-button>
                                        </div>
                                        <div class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.firma.tanimlama.firmaKodu")'
                                                    prop="firmaKodu">:
                                                <el-input
                                                        v-model="firmaForm.firmaKodu" disabled
                                                        :placeholder='$t("src.views.apps.firma.tanimlama.firmaKoduPlace")'></el-input>
                                            </el-form-item>
                                        </div>
                                        <div>
                                            <el-row>
                                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                    <el-form-item
                                                            :label='$t("src.views.apps.firma.tanimlama.firmaAdi")'
                                                            prop="firmaAdi">:
                                                        <el-input
                                                                v-model="firmaForm.firmaAdi" disabled
                                                                :placeholder='$t("src.views.apps.firma.tanimlama.firmaPlace")'></el-input>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                        </div>
                                        <div class="col-p" style="margin: 5px 0">
                                            <el-form-item
                                                    :label='$t("src.views.apps.firma.tanimlama.vergiDairesi")'
                                                    prop="vergiDairesi">:
                                                <el-input
                                                        v-model="firmaForm.vergiDairesi" disabled
                                                        :placeholder='$t("src.views.apps.firma.tanimlama.vergiDairesiPlace")'></el-input>
                                            </el-form-item>
                                        </div>
                                        <div class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.firma.tanimlama.vergiNo")'
                                                    prop="vergiNo">:
                                                <el-input
                                                        v-model="firmaForm.vergiNo" disabled
                                                        v-mask="'##########################'"
                                                        :placeholder='$t("src.views.apps.firma.tanimlama.vergiNoPlace")'></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :lg="12" :md="12" :sm="24" :xs="24">
                        <div class="flip-card" id="flipSite">
                            <div class="flip-card-inner">
                                <div class="card-base card-shadow--medium">
                                    <el-col :span="24" class="flip-card-front">
                                        <el-row>
                                            <el-button v-if="root || guncellemeYetkisi" v-on:click="editShow('#flipSite')"
                                                       type="warning" size="mini"
                                                       icon="el-icon-edit"></el-button>
                                            <el-divider content-position="left">Site Bilgileri</el-divider>
                                            <div class="flex center demo-box" style="min-height: 277px">
                                                <div class="right-box box grow">
                                                    <dl class="horizontal">
                                                        <dt><i class="mdi mdi-cursor-default"></i>{{$t("src.views.apps.firma.tanimlama.siteAdi")}}
                                                        </dt>
                                                        <dd>: {{this.firmadetayi.siteAdi}}</dd>
                                                        <el-divider></el-divider>
                                                        <dt><i class="mdi mdi-new-box"></i>{{$t("src.views.apps.firma.tanimlama.slogan")}}
                                                        </dt>
                                                        <dd>: {{this.firmadetayi.slogan}}</dd>
                                                        <el-divider></el-divider>
                                                        <dt><i class="mdi mdi-web"></i>{{$t("src.views.apps.firma.tanimlama.siteAdresi")}}
                                                        </dt>
                                                        <dd>: {{this.firmadetayi.siteAdresi}}</dd>
                                                        <el-divider></el-divider>
                                                        <dt><i class="mdi mdi-web"></i>{{$t("src.views.apps.firma.tanimlama.siteAdresi2")}}
                                                        </dt>
                                                        <dd>: {{this.firmadetayi.siteAdresi2}}</dd>
                                                    </dl>
                                                </div>
                                            </div>
                                        </el-row>
                                    </el-col>
                                    <el-col :span="24" class="flip-card-back">
                                        <div class="btnBack">
                                            <el-button v-on:click="firmaGuncelleme('formName','#flipSite')"
                                                       type="success"
                                                       size="mini"
                                                       icon="el-icon-check"></el-button>
                                            <el-button v-on:click="editClose('#flipSite')" type="danger" size="mini"
                                                       icon="el-icon-close"></el-button>
                                        </div>
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.siteAdi")'
                                                              prop="siteAdi">:
                                                    <el-input v-model="firmaForm.siteAdi"
                                                              :placeholder='$t("src.views.apps.firma.tanimlama.firmaPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.slogan")'
                                                              prop="slogan">:
                                                    <el-input
                                                            v-model="firmaForm.slogan"
                                                            :placeholder='$t("src.views.apps.firma.tanimlama.sloganPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.siteAdresi")'
                                                              prop="siteAdresi">:
                                                    <el-input
                                                            v-model="firmaForm.siteAdresi"
                                                            :placeholder='$t("src.views.apps.firma.tanimlama.siteAdresiPlace")'>
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.siteAdresi2")'
                                                              prop="siteAdresi2">:
                                                    <el-input
                                                            v-model="firmaForm.siteAdresi2"
                                                            :placeholder='$t("src.views.apps.firma.tanimlama.siteAdresiPlace")'>
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 10px">
                    <el-col :span="24">
                        <div class="flip-card" id="flipIletisim">
                            <div class="flip-card-inner">
                                <div class="card-base card-shadow--medium">
                                    <el-col :span="24" class="flip-card-front">
                                        <el-row>
                                            <el-button v-if="root || guncellemeYetkisi" v-on:click="editShow('#flipIletisim')"
                                                       type="warning" size="mini"
                                                       icon="el-icon-edit"></el-button>
                                            <el-divider content-position="left">İletişim Bilgileri</el-divider>
                                            <div class="flex center demo-box">
                                                <div class="right-box box grow">
                                                    <dl class="horizontal">
                                                        <dt><i class="mdi mdi-email"></i>{{$t("src.views.apps.firma.tanimlama.eposta")}}
                                                        </dt>
                                                        <dd>: {{this.firmadetayi.eposta}}</dd>
                                                        <el-divider></el-divider>
                                                        <dt><i class="mdi mdi-email"></i>{{$t("src.views.apps.firma.tanimlama.eposta2")}}
                                                        </dt>
                                                        <dd>: {{this.firmadetayi.eposta2}}</dd>
                                                        <el-divider></el-divider>
                                                        <dt><i class="mdi mdi-account-badge-horizontal"></i>{{$t("src.views.apps.firma.tanimlama.yetkiliId")}}
                                                        </dt>
                                                        <dd>: {{this.yetkiliAdSoyad}}</dd>
                                                        <el-divider></el-divider>
                                                        <dt><i class="mdi mdi-phone"></i>{{$t("src.views.apps.firma.tanimlama.telefon")}}
                                                        </dt>
                                                        <dd>: {{this.firmadetayi.telefon2}}</dd>
                                                        <el-divider></el-divider>
                                                        <dt><i class="mdi mdi-phone-classic"></i>{{$t("src.views.apps.firma.tanimlama.telefon2")}}
                                                        </dt>
                                                        <dd>: {{this.firmadetayi.telefon}}</dd>
                                                        <el-divider></el-divider>
                                                        <dt><i class="mdi mdi-phone-classic"></i>{{$t("src.views.apps.firma.tanimlama.dahili")}}
                                                        </dt>
                                                        <dd>: {{this.firmadetayi.dahili}}</dd>
                                                        <el-divider></el-divider>
                                                        <dt><i class="mdi mdi-fax"></i>{{$t("src.views.apps.firma.tanimlama.fax")}}
                                                        </dt>
                                                        <dd>: {{this.firmadetayi.fax}}</dd>
                                                        <el-divider></el-divider>
                                                        <dt><i class="mdi mdi-map-marker"></i>{{$t("src.views.apps.firma.tanimlama.adres")}}
                                                        </dt>
                                                        <dd>: {{this.firmadetayi.adres}}</dd>
                                                        <el-divider></el-divider>
                                                        <dt><i class="mdi mdi-map-marker"></i>{{$t("src.views.apps.firma.tanimlama.koordinat")}}
                                                        </dt>
                                                        <dd>: {{this.firmadetayi.koordinat}}</dd>
                                                        <div v-if="firmadetayi.facebook">
                                                            <el-divider></el-divider>
                                                            <dt><i class="mdi mdi-facebook"></i>Facebook
                                                            </dt>
                                                            <el-link target="_blank" :underline="false"
                                                                     :href="this.firmadetayi.facebook">
                                                                <dd>: {{this.firmadetayi.facebook}}</dd>

                                                            </el-link>
                                                        </div>
                                                        <div v-if="firmadetayi.instagram">
                                                            <el-divider></el-divider>
                                                            <dt><i class="mdi mdi-instagram"></i>Instagram</dt>
                                                            <el-link target="_blank" :underline="false"
                                                                     :href="this.firmadetayi.instagram">
                                                                <dd>: {{this.firmadetayi.instagram}}</dd>
                                                            </el-link>
                                                        </div>
                                                        <div v-if="firmadetayi.twitter">
                                                            <el-divider></el-divider>
                                                            <dt><i class="mdi mdi-twitter"></i>Twitter
                                                            </dt>
                                                            <el-link target="_blank" :underline="false"
                                                                     :href="this.firmadetayi.twitter">
                                                                <dd>: {{this.firmadetayi.twitter}}</dd>

                                                            </el-link>
                                                        </div>
                                                        <div v-if="firmadetayi.linkedin">
                                                            <el-divider></el-divider>
                                                            <dt><i class="mdi mdi-linkedin"></i>LinkedIn
                                                            </dt>
                                                            <el-link target="_blank" :underline="false"
                                                                     :href="this.firmadetayi.linkedin">
                                                                <dd>: {{this.firmadetayi.linkedin}}</dd>

                                                            </el-link>
                                                        </div>
                                                        <div v-if="firmadetayi.google">
                                                            <el-divider></el-divider>
                                                            <dt><i class="mdi mdi-google"></i>Google
                                                            </dt>
                                                            <el-link target="_blank" :underline="false"
                                                                     :href="this.firmadetayi.google">
                                                                <dd>: {{this.firmadetayi.google}}</dd>

                                                            </el-link>
                                                        </div>
                                                        <div v-if="firmadetayi.youtube">
                                                            <el-divider></el-divider>
                                                            <dt><i class="mdi mdi-youtube"></i>YouTube
                                                            </dt>
                                                            <el-link target="_blank" :underline="false"
                                                                     :href="this.firmadetayi.youtube">
                                                                <dd>: {{this.firmadetayi.youtube}}</dd>

                                                            </el-link>
                                                        </div>
                                                        <div v-if="firmadetayi.swarm">
                                                            <el-divider></el-divider>
                                                            <dt><i class="mdi mdi-swarm"></i>Swarm
                                                            </dt>
                                                            <el-link target="_blank" :underline="false"
                                                                     :href="this.firmadetayi.swarm">
                                                                <dd>: {{this.firmadetayi.swarm}}</dd>
                                                            </el-link>
                                                        </div>
                                                        <div v-if="firmadetayi.watsapp">
                                                            <el-divider></el-divider>
                                                            <dt><i class="mdi mdi-whatsapp"></i>WhatsApp
                                                            </dt>
                                                            <el-link target="_blank" :underline="false"
                                                                     :href="this.firmadetayi.watsapp">
                                                                <dd>: {{this.firmadetayi.watsapp}}</dd>

                                                            </el-link>
                                                        </div>
                                                        <div v-if="firmadetayi.skype">
                                                            <el-divider></el-divider>
                                                            <dt><i class="mdi mdi-skype"></i>Skype
                                                            </dt>
                                                            <el-link target="_blank" :underline="false"
                                                                     :href="this.firmadetayi.skype">
                                                                <dd>: {{this.firmadetayi.skype}}</dd>

                                                            </el-link>
                                                        </div>
                                                    </dl>
                                                </div>
                                            </div>
                                        </el-row>
                                    </el-col>
                                    <el-col :span="24" class="flip-card-back">
                                        <div class="btnBack">
                                            <el-button v-on:click="firmaGuncelleme('formName','#flipIletisim')"
                                                       type="success"
                                                       size="mini"
                                                       icon="el-icon-check"></el-button>
                                            <el-button v-on:click="editClose('#flipIletisim')" type="danger" size="mini"
                                                       icon="el-icon-close"></el-button>
                                        </div>
                                        <el-row style="margin-top: 10px">
                                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.firma.tanimlama.yetkiliId")'
                                                        prop="yetkiliId">:
                                                    <el-select

                                                            v-model="firmaForm.yetkiliId"
                                                            filterable
                                                            :placeholder='$t("src.views.apps.firma.tanimlama.yetkiliIdPlace")'
                                                            style="width: 100%">
                                                        <el-option
                                                                v-for="item in yetkiliList"
                                                                :key="item.yonetimId"
                                                                :label="item.adSoyad"
                                                                :value="item.yonetimId"></el-option>
                                                    </el-select>
                                                </el-form-item>

                                            </el-col>
                                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.eposta")'
                                                              prop="eposta">:
                                                    <el-input
                                                            v-model="firmaForm.eposta"
                                                            placeholder='info@erasmus.com.tr'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.eposta2")'
                                                              prop="eposta2">:
                                                    <el-input
                                                            v-model="firmaForm.eposta2"
                                                            placeholder='info@erasmus.com.tr'></el-input>
                                                </el-form-item>
                                            </el-col>

                                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.telefon")'
                                                              prop="telefon">:
                                                    <el-input
                                                            v-model="firmaForm.telefon" v-mask="'+90(###)### ## ##'"
                                                            placeholder="+90(0555)555 55 55"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.telefon2")'
                                                              prop="telefon2">:
                                                    <el-input
                                                            v-model="firmaForm.telefon2" v-mask="'+90(###)### ## ##'"
                                                            placeholder="+90(0555)555 55 55"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.dahili")'
                                                              prop="dahili">:
                                                    <el-input
                                                            v-model="firmaForm.dahili" v-mask="'######'"
                                                            placeholder="555555"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.fax")'
                                                              prop="fax">:
                                                    <el-input
                                                            v-model="firmaForm.fax" v-mask="'+90(346)### ## ##'"
                                                            placeholder="(+90)346-555 55 55"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.adres")'
                                                              prop="adres">:
                                                    <el-input type="textarea"
                                                              v-model="firmaForm.adres"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.koordinat")'
                                                              prop="koordinat">:
                                                    <el-input v-model="firmaForm.koordinat"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.sosyal")'
                                                              prop="valueAna">
                                                    <el-select

                                                            v-model="firmaForm.valueAna"
                                                            style="width: 100%"
                                                            multiple
                                                            filterable
                                                            allow-create
                                                            default-first-option
                                                            placeholder="Facebook, Instagram, Twitter...">
                                                        <el-option
                                                                v-for="item in options"
                                                                :key="item.value"
                                                                :label="item.label"
                                                                :value="item">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row v-for="(detay,index) in firmaForm.valueAna" v-bind:key="index">
                                            <el-col :span="24" class="col-p">
                                                <el-form-item :label='detay.label'>:
                                                    <el-row :gutter="20">
                                                        <el-col :span="12">
                                                            <el-input v-model="firmaForm[detay.value]"
                                                                      :prop='firmaForm[detay.value]'
                                                                      v-on:change="sosyalKontrol(detay.value)"></el-input>
                                                        </el-col>
                                                        <el-col :span="10">
                                                            <el-button
                                                                    type="danger"
                                                                    size="mini"
                                                                    icon="el-icon-close"
                                                                    v-on:click="removeRowFirma(index,detay.value)">
                                                            </el-button>
                                                        </el-col>
                                                    </el-row>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
    </div>
</template>
<script>
    import firmaService from '../../../WSProvider/FirmaService'
    import notification from '../../../notification'
    import JQuery from 'jquery';

    let $ = JQuery;

    let base64 = require('base64_js');
    let userData3H = "";
    export default {
        name: "FirmaDetay",
        mounted() {
            let self = this;
            if (localStorage.getItem("userData3H")) {
                userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
                if (userData3H["yetki"]) {
                    userData3H["yetki"].forEach(function (value) {
                        switch (value.yetkiKodu) {
                            case 'YK-866521':
                                self.guncellemeYetkisi = true;
                                break;
                        }
                    });
                }
                if (userData3H["tur"] === "1") {
                    self.root = true;
                }
            }
            this.firmaDetayList();
        },
        data() {
            return {
                root : false,
                guncellemeYetkisi: false,
                options: [{value: 'facebook', label: 'Facebook'},
                    {value: 'twitter', label: 'Twitter'},
                    {value: 'google', label: 'Google'},
                    {value: 'instagram', label: 'Instagram'},
                    {value: 'linkedin', label: 'LinkedIn'},
                    {value: 'youtube', label: 'YouTube'},
                    {value: 'swarm', label: 'Swarm'},
                    {value: 'watsapp', label: 'WhatsApp'},
                    {value: 'skype', label: 'Skype'}],
                valueVisible: true,
                sosyalMedya: [],
                yetkiliList: [],
                firmaDetayListKlon: [],
                updateData: [],
                firmaId: '',
                yetkiliAdSoyad: '',
                firmadetayi: {},
                firmaForm: {
                    firmaKodu: '',
                    renk: '',
                    firmaAdi: '',
                    vergiDairesi: '',
                    vergiNo: '',
                    siteAdi: '',
                    valueAna: [],
                    yetkiliId: "",
                    adSoyad: "",
                    slogan: "",
                    siteAdresi: '',
                    siteAdresi2: '',
                    eposta: '',
                    eposta2: '',
                    telefon: '',
                    telefon2: '',
                    dahili: '',
                    fax: '',
                    adres: '',
                    koordinat: '',
                    facebook: '',
                    twitter: '',
                    google: '',
                    instagram: '',
                    linkedin: '',
                    youtube: '',
                    swarm: '',
                    watsapp: '',
                    skype: '',
                },
                rulesFirma: {
                    eposta: [
                        {type: 'email', message: 'Lütfen Geçerli Bir Email Giriniz', trigger: ['blur', 'change']}
                    ],
                    eposta2: [
                        {type: 'email', message: 'Lütfen Geçerli Bir Email Giriniz', trigger: ['blur', 'change']}
                    ],
                },
            }
        },
        methods: {
            editShow(id) {
                $(id).addClass('flipac');
                this.valueVisible = false;
            },
            editClose(id) {
                $(id).removeClass('flipac');
                this.valueVisible = true;
            },
            sosyalKontrol(sosyal) {
                this.sosyalMedya.push({
                    title: sosyal,
                    value: this.firmaForm[sosyal]
                })
            },
            removeRowFirma(item, value) {
                this.firmaForm.valueAna.splice(item, 1);
                for (var i = 0; i < this.sosyalMedya.length; i++) {
                    if (value === this.sosyalMedya[i].title) {
                        this.sosyalMedya.splice(i, 1);
                    }
                }
            },
            firmaDetayList() {
                let self = this;
                firmaService.firmaDetay().then((response) => {
                    if (!response.data) {
                        notification.Status('warning', this, 'Firma detayı bulunamadı..');
                        history.back();
                    }
                    if (response.status === 200) {
                        this.firmadetayi = response.data;
                        this.firmaId = response.data.firmaId;
                        this.yetkiliAdSoyad = response.data.adSoyad;
                        this.firmaForm.firmaKodu = response.data.firmaKodu;
                        this.firmaForm.firmaAdi = response.data.firmaAdi;
                        this.firmaForm.vergiDairesi = response.data.vergiDairesi;
                        this.firmaForm.vergiNo = response.data.vergiNo;
                        this.firmaForm.siteAdi = response.data.siteAdi;
                        this.firmaForm.yetkiliId = response.data.yetkiliId;
                        this.firmaForm.adSoyad = response.data.adSoyad;
                        this.firmaForm.slogan = response.data.slogan;
                        this.firmaForm.renk = response.data.renk;
                        this.firmaForm.siteAdresi = response.data.siteAdresi;
                        this.firmaForm.siteAdresi2 = response.data.siteAdresi2;
                        this.firmaForm.eposta = response.data.eposta;
                        this.firmaForm.eposta2 = response.data.eposta2;
                        this.firmaForm.telefon = response.data.telefon;
                        this.firmaForm.telefon2 = response.data.telefon2;
                        this.firmaForm.fax = response.data.fax;
                        this.firmaForm.adres = response.data.adres;
                        this.firmaForm.koordinat = response.data.koordinat;
                        this.options.forEach(function (e) {
                            if (response.data[e.value] !== null) {
                                var items = {
                                    label: e.label,
                                    value: e.value
                                };
                                self.firmaForm.valueAna.push(items);
                                self.firmaForm[e.value] = response.data[e.value];
                            }
                        });
                        this.firmaDetayListKlon = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            firmaGuncelleme(formName, konu) {
                this.updateData = [];
                for (var key in this.firmaDetayListKlon) {
                    if (this.firmaDetayListKlon[key] !== this.firmaForm[key]) {
                        if (this.firmaForm[key]) {
                            var item = {
                                type: key,
                                value: this.firmaForm[key]
                            };
                            this.updateData.push(item);
                        }
                    }
                }
                let self = this;
                // console.log(this.updateData);
                if (this.updateData.length !== 0) {
                    firmaService.firmaGuncelle(this.updateData).then((response) => {
                        if (response.status === 200) {
                            notification.Status('success', this, 'Firma başarıyla güncellendi.');
                            self.firmadetayi = response.data;
                            $(konu).removeClass('flipac');
                            this.firmaDetayListKlon = response.data;
                        } else if (response.status === 230) {
                            notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir firma zaten mevcut');
                        } else {
                            notification.Status(response.status, this)
                        }
                    });
                } else
                    notification.Status('warning', this, 'Herhangi bir değişiklik yapılmadı..');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables';

    .el-row:first-child {
        margin-top: unset !important;
    }

    .page-table {
        &.overflow {
            overflow: hidden;
        }

        .table-box {
            overflow: hidden;
        }
    }

    .el-form-item {
        font-weight: bold;
        margin-bottom: 15px !important;
    }

    /*Flip*/
    #flipFirma, #flipSite {
        width: 100%;
        height: auto;
        perspective: 1000px;
    }

    #flipIletisim {
        width: 100%;
        height: auto;
        perspective: 2500px;
    }

    .flip-card-inner {
        position: relative;
        width: 100%;
        height: 100%;
        /*text-align: center;*/
        transition: transform 0.8s;
        transform-style: preserve-3d;
    }

    .flip-card.flipac .flip-card-inner {
        transform: rotateY(180deg);
    }

    .flip-card-front {
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
    }

    .flip-card-back {
        position: absolute;
        transform: rotateY(-180deg) translateZ(1px);
        top: 0;
        left: 0;
        width: 100%;
        /*height: 100%;*/
        background: #fff;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
    }

    .flip-card-front .el-button {
        display: block;
        margin-left: auto;
        margin-top: 20px;
        margin-right: 20px;
    }

    .btnBack {
        display: flex;
        justify-content: flex-end;
        position: relative;
        top: 10px;
        right: 10px;
        z-index: 100;
    }

    dl i {
        color: #0075c3;
        margin: 0 10px;
    }

    .el-divider--horizontal {
        margin: 22px 0;
    }

    dl.horizontal dt {
        text-align: left;
        width: 25% !important;
    }

    dl.horizontal dd {
        margin-left: unset;
    }

    /*Flip*/
</style>